import { useEffect, useMemo, useState } from 'react';

// Utils
import { getMobileOS } from 'utils/detect-mobile';
import useWindowSize from 'utils/hooks/useWindowSize';
import { SCREEN_SIZES } from '../../constants/common';

/**
 * Функция отпределяет тип устройства и возвращает булевое значение;
 */
export const useIsMobile = (defaultVal = null) => {
  const [isMobile, setMobileOs] = useState(defaultVal);

  useEffect(() => {
    setMobileOs(!!getMobileOS());
  }, []);

  return isMobile;
};

/**
 * Функция отпределяет тип устройства и возвращает тип устройства в виде строки;
 */
export const useMobileOs = (defaultVal = null) => {
  const [mobileOs, setMobileOs] = useState(defaultVal);

  useEffect(() => {
    setMobileOs(getMobileOS());
  }, []);

  return mobileOs;
};

/**
 * Функция определяет ширину экрана и возвращает булевое значение,  если  оно меньше десктопа;
 */

export const useIsMobileWidth = (defaultVal = null) => {
  const [isMobile, setIsMobile] = useState(defaultVal);
  const { width } = useWindowSize();

  useMemo(() => {
    setIsMobile(width < SCREEN_SIZES.MOBILE);
  }, [width]);

  return isMobile;
};
